/**
 * Where templates live: the list at `/permissions/templates`, one template at
 * `/permissions/templates/{id}`, and a new one at `/permissions/templates/new`.
 */

export const TEMPLATES_PATH = "/permissions/templates";
export const NEW_TEMPLATE_PATH = `${TEMPLATES_PATH}/new`;

export function templatePath(templateId: string): string {
  return `${TEMPLATES_PATH}/${templateId}`;
}
